import customerReview from './customerReview.css' 
import saledFlying from '../assets/Salad-flying.png'   
import mixedFruits from '../assets/mixedFruits.png'  
import customer from '../assets/customer.jfif'
import {FaArrowCircleLeft} from 'react-icons/fa' 
import {FaArrowCircleRight} from 'react-icons/fa'



function CustomerReview(){
return (
    <>
    <div className='customerReview'>
    <div className='customerReview__contianer'>
    <div className='customerReview__header'> Customer Review</div>
    <div className='customerReview__carosel-frame'>
    <div className='customerReview__carosel rv1'>
    <div className='customerReview__carosel-text'>
        Lorem ipusm Lorem ipusm Lorem ipusm Lorem ipusm Lorem ipusmLorem ipusm Lorem ipusm
        Lorem ipusm Lorem ipusm Lorem ipusmLorem ipusm Lorem ipusm Lorem ipusm Lorem ipusm
    </div>
    <div className='customerReview__carosel-img'>
    <div className='customerReview__carosel-img-ph'><img src = {customer} className='customerReview__carosel-img-main'/></div>
    <div className='customerReview__carosel-img-name'>
    <div className='customerReview__carosel-img-fullname'> Mrs. Charles Xavi</div>
    <div className='customerReview__carosel-img-tittle'> Civil Enginer</div>
    </div>
    </div>
    </div>

    <div className='customerReview__carosel rv2'>
    <div className='customerReview__carosel-text'>
        Lorem ipusm Lorem ipusm Lorem ipusm Lorem ipusm Lorem ipusmLorem ipusm Lorem ipusm
        Lorem ipusm Lorem ipusm Lorem ipusmLorem ipusm Lorem ipusm Lorem ipusm Lorem ipusm
    </div>
    <div className='customerReview__carosel-img'>
    <div className='customerReview__carosel-img-ph'><img src = {customer} className='customerReview__carosel-img-main'/></div>
    <div className='customerReview__carosel-img-name'>
    <div className='customerReview__carosel-img-fullname'> Mrs. Charles Xavi</div>
    <div className='customerReview__carosel-img-tittle'> Civil Enginer</div>
    </div>
    </div>
    </div>

    <div className='customerReview__carosel rv3'>
    <div className='customerReview__carosel-text'>
        Lorem ipusm Lorem ipusm Lorem ipusm Lorem ipusm Lorem ipusmLorem ipusm Lorem ipusm
        Lorem ipusm Lorem ipusm Lorem ipusmLorem ipusm Lorem ipusm Lorem ipusm Lorem ipusm
    </div>
    <div className='customerReview__carosel-img'>
    <div className='customerReview__carosel-img-ph'><img src = {customer} className='customerReview__carosel-img-main'/></div>
    <div className='customerReview__carosel-img-name'>
    <div className='customerReview__carosel-img-fullname'> Mrs. Charles Xavi</div>
    <div className='customerReview__carosel-img-tittle'> Civil Enginer</div>
    </div>
    </div>
    <div className='customerReview__carosel-arrow'>
        <FaArrowCircleLeft className='customerReview__carosel-arrow-L' />
        <FaArrowCircleRight  className='customerReview__carosel-arrow-R' />
    </div>
    </div>
    
    </div>
    </div>
    </div>
    </>
)
}

export default CustomerReview;